
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { getWeekdayWaitAverages } from '../../lib/dbFetcher';
const SLUGS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
async function getStaticProps() {
    let days;
    try {
        days = await getWeekdayWaitAverages();
    }
    catch (error) {
        console.error('Error building travel-times hub:', error);
        days = Array.from({ length: 7 }, (_, i) => ({
            dow: i + 1,
            avgLow: null,
            busiestHour: null,
            busiestAvg: null
        }));
    }
    return { props: { days }, revalidate: 3600 };
}
function formatHour(h) {
    if (h == null)
        return null;
    return `${String(h).padStart(2, '0')}:00`;
}
function TravelTimesHub({ days }) {
    const { t } = useTranslation('travel-times');
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('hub_meta_title')}</title>
                <meta name="description" content={t('hub_meta_description')}/>
                <meta name="robots" content="all"/>
                <meta property="og:title" content={t('hub_meta_title')}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">{t('hub_title')}</h1>
            <p className="mt-3 text-gray-600">{t('hub_intro')}</p>

            <table className="mt-6 w-full text-left border-collapse">
                <thead>
                    <tr className="border-b">
                        <th className="py-2">{t('col_day')}</th>
                        <th className="py-2">{t('col_avg')}</th>
                        <th className="py-2">{t('col_busiest')}</th>
                    </tr>
                </thead>
                <tbody>
                    {days.map((d) => (<tr key={d.dow} className="border-b">
                            <td className="py-2">
                                <Link href={`/travel-times/${SLUGS[d.dow - 1]}`} className="text-[var(--secondary)] underline">
                                    {t(`day_${d.dow}`)}
                                </Link>
                            </td>
                            <td className="py-2">
                                {d.avgLow != null ? d.avgLow : '-'}
                            </td>
                            <td className="py-2">
                                {formatHour(d.busiestHour) || '-'}
                            </td>
                        </tr>))}
                </tbody>
            </table>

            <p className="mt-4 text-xs text-gray-500">{t('source_note')}</p>

            <div className="mt-6">
                <Link href="/" className="text-[var(--secondary)] underline">
                    {t('cta_live')}
                </Link>
            </div>
        </div>);
}
export default TravelTimesHub;

    async function __Next_Translate__getStaticProps__1a1723ec74e__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/travel-times/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec74e__ as getStaticProps }
  